import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropModalHeader = ({
  config,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "start",
    paddingBlock: "500",
    paddingInline: "600",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: config.headerKey
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: config.subheaderKey
        })
      })]
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    })]
  });
};
export default ValuePropModalHeader;